import { render, staticRenderFns } from "./xtk-list.vue?vue&type=template&id=7ff0d76b&"
import script from "./xtk-list.vue?vue&type=script&lang=ts&"
export * from "./xtk-list.vue?vue&type=script&lang=ts&"
import style0 from "./xtk-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports